import type { DailyStatusView, ScoreCard, ScoreSlot } from '../../lib/dailyStatus'

/**
 * The slot the recording card carries, rather than a ring and a row.
 *
 * R13: signal quality is rendered ONCE, on the recording card, because it is a
 * property of the recording rather than one of the six things measured in it —
 * and because it gates the rest, so it belongs where the reader meets the
 * session, not sixth in a grid of dials.
 */
export const RECORDING_SLOT: ScoreSlot = 'signal_quality'

/**
 * The six the hero rings and the measure rows draw, derived IN THE VIEW.
 *
 * The read model is never filtered: `SCORE_SLOTS` stays eight and
 * `status.scores` stays length eight, which is what `dailyStatus.test.ts`
 * pins. This is the one definition of "the six" — eight, minus the
 * research-only slots, minus the one the recording card carries — so a ring
 * grid and a row list cannot drift apart into two different sets.
 */
export const ringSet = (status: DailyStatusView): ScoreCard[] =>
  status.scores.filter((card) => !card.researchOnly && card.slot !== RECORDING_SLOT)
